import { RoleCode } from 'corso-types';
import { useStoreUser } from '~/providers/StoreUserProvider';
import { useUser } from '~/providers/UserProvider';

// TODO split hooks into separate files, or rename this file to better reflect its contents

function useIsTest() {
  const storeUser = useStoreUser();

  return storeUser.store.isTest ?? false;
}

/**
 * Use to determine if a user is a Corso admin.
 * Otherwise, it is determined by the user's role code.
 */
export default function useIsCorsoAdmin() {
  const storeUser = useStoreUser();
  const isTest = useIsTest();

  // TODO include check for is within Corso organization; i.e. `isCorsoUser` or `isCorsoMember`
  return storeUser.roleCode === RoleCode.corsoAdmin || isTest;
}

/**
 * A Corso employee acting on a merchant's behalf. Read from the Corso org membership
 * rather than the store role, which the API fans out as an indistinguishable `Staff`.
 */
// TODO simplify so that it can short circuit from `useIsCorsoAdmin` hook
export function useIsCorsoCxAgent() {
  const user = useUser();

  return user.organizationUserRoles.some(
    (o) =>
      o.isCorsoOrg &&
      (o.roleCode === RoleCode.staff || o.roleCode === RoleCode.corsoAdmin),
  );
}
